// extracted by css-extract-rspack-plugin
module.exports =  {"material":"TeacherMaterial-NQhs__material"};